import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, ChevronRight, Sparkles } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function Pricing() {
  return <section id="compra" className="py-12 px-4 bg-brand-black relative" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card rounded-3xl p-6 md:p-10 text-center text-white shadow-2xl relative overflow-hidden border border-brand-green/20" data-id="element-115">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-green/15 rounded-full blur-[80px]" data-id="element-116"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-green/15 rounded-full blur-[80px]" data-id="element-117"></div>

          <div className="relative z-10" data-id="element-118">
            <h2 className="font-display text-2xl md:text-4xl uppercase mb-3" data-id="element-119">
              Empezá a ganar <span className="text-brand-green" data-id="element-120">hoy mismo</span>
            </h2>
            <p className="font-body text-sm md:text-base text-gray-300 mb-5 max-w-2xl mx-auto" data-id="element-121">
              Llevate los 6 Tomos de Padel Zurdo Pro + los 3 Bonos Exclusivos
              con acceso inmediato.
            </p>

            <CountdownTimer data-id="element-122" />

            <div className="grid grid-cols-1 md:grid-cols-3 items-stretch justify-center gap-4 max-w-4xl mx-auto mb-6" data-id="element-123">
              <div className="bg-brand-black rounded-2xl px-6 py-6 border border-brand-green/30 flex flex-col justify-center" data-id="element-124">
                <p className="font-body text-gray-500 line-through text-base mb-2" data-id="element-125">
                  Precio normal: $49.990
                </p>
                <div className="flex items-baseline justify-center gap-1 mb-2" data-id="element-126">
                  <span className="font-display text-xl text-brand-green" data-id="element-127">
                    $
                  </span>
                  <span className="font-display text-5xl text-white leading-none" data-id="element-128">
                    19.990
                  </span>
                  <span className="font-display text-base text-brand-green ml-1" data-id="element-129">
                    ARS
                  </span>
                </div>
                <p className="font-body text-brand-green font-medium text-xs" data-id="element-130">
                  Pago único · Acceso de por vida.
                </p>
              </div>

              <div className="relative bg-brand-green/10 rounded-2xl border-2 border-dashed border-brand-green text-left flex flex-col overflow-hidden" data-id="element-131">
                <div className="relative w-full h-24 overflow-hidden" data-id="element-132">
                  <img src="https://cdn.magicpatterns.com/uploads/uB7BJyRYrXncHKejEwZdcm/image.png" alt="Bono PRO AntiRivales" loading="eager" decoding="async" className="w-full h-full object-cover object-top" data-id="element-133" />
                  <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-green/5 to-brand-card pointer-events-none" data-id="element-134"></div>
                </div>
                <div className="absolute -top-2.5 left-4 bg-brand-green text-brand-black font-display text-[10px] px-2 py-0.5 rounded-full uppercase tracking-wider flex items-center gap-1 z-10" data-id="element-135">
                  <Sparkles className="w-3 h-3" data-id="element-136" />
                  Regalo de hoy
                </div>
                <div className="px-5 pb-5 -mt-3 relative z-10" data-id="element-137">
                  <p className="font-body text-[11px] text-brand-green font-bold uppercase tracking-wider mb-1" data-id="element-138">
                    Llevate sin cargo HOY
                  </p>
                  <p className="font-display text-base md:text-lg text-white uppercase leading-tight mb-1" data-id="element-139">
                    Bono PRO — AntiRivales
                  </p>
                  <p className="font-body text-xs text-gray-300 leading-snug" data-id="element-140">
                    Cómo leer y destruir estilos de juego específicos.
                  </p>
                </div>
              </div>

              <div className="relative bg-brand-green/10 rounded-2xl px-5 py-5 border-2 border-dashed border-brand-green text-left flex flex-col justify-center" data-id="element-141">
                <div className="absolute -top-2.5 left-4 bg-brand-green text-brand-black font-display text-[10px] px-2 py-0.5 rounded-full uppercase tracking-wider flex items-center gap-1" data-id="element-142">
                  <Sparkles className="w-3 h-3" data-id="element-143" />
                  Regalo de hoy
                </div>
                <p className="font-body text-[11px] text-brand-green font-bold uppercase tracking-wider mb-2" data-id="element-144">
                  Llevate sin cargo HOY
                </p>
                <ul className="space-y-1.5" data-id="element-145">
                  <li className="font-body text-xs text-gray-200 flex items-start gap-1.5 leading-snug" data-id="element-146">
                    <span className="text-brand-green mt-0.5" data-id="element-147">✓</span>
                    Calculadora de proteínas e hidratación
                  </li>
                  <li className="font-body text-xs text-gray-200 flex items-start gap-1.5 leading-snug" data-id="element-148">
                    <span className="text-brand-green mt-0.5" data-id="element-149">✓</span>
                    Cuadro de suplementos con respaldo científico
                  </li>
                  <li className="font-body text-xs text-gray-200 flex items-start gap-1.5 leading-snug" data-id="element-150">
                    <span className="text-brand-green mt-0.5" data-id="element-151">✓</span>
                    Test de progreso 60 días
                  </li>
                </ul>
              </div>
            </div>

            <a href="https://checkout.ebookpoint.shop/cart/59466975805521:1" className="inline-flex items-center justify-center gap-2 bg-brand-green hover:bg-brand-darkGreen text-brand-black font-display text-lg md:text-xl py-4 px-8 rounded-xl transition-all transform hover:scale-105 hover:shadow-xl hover:shadow-brand-green/30 w-full md:w-auto mb-5" data-id="element-152">
              QUIERO USAR MI ZURDA COMO VENTAJA
              <ChevronRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-153" />
            </a>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-xs font-body text-gray-400" data-id="element-154">
              <div className="flex items-center gap-2" data-id="element-155">
                <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-156" />
                <span data-id="element-157">Garantía de satisfacción</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-158">
                <Lock className="w-4 h-4 text-brand-green" data-id="element-159" />
                <span data-id="element-160">Pago 100% seguro</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}